<template>
    <footer class="footer-container bg-secondary mt-auto">
        <div class="container">
            <div class="footer-links mt-4 mb-5">
                <div class="row">
                    <div class="col-12 col-sm-3 text-center text-md-left">
                        <h5 class="font-weight-bold">goLOTUS</h5>
                        <ul class="links pl-0">
                            <li v-for="c in golotus" :key="c.title">
                                <a :href="c.url">{{ c.title }}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 col-sm-3 text-center text-md-left">
                        <h5 class="font-weight-bold">Let Us Help You</h5>
                        <ul class="links pl-0">
                            <li v-for="c in letushelp" :key="c.title">
                                <a :href="c.url">{{ c.title }}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 col-sm-3 text-center text-md-left">
                        <h5 class="font-weight-bold">About Us</h5>
                        <ul class="links pl-0">
                            <li v-for="c in aboutus" :key="c.title">
                                <a :href="c.url">{{ c.title }}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 col-sm-3 social pl-5-md text-center text-md-left">
                        <h5 class="font-weight-bold mb-3">Follow us</h5>
                        <p>
                            <i v-if="false" class="fa fa-twitter-square fa-3x mr-3"></i>
                            <a class="" href="https://www.facebook.com/golotusinc/" target="_blank"
                                ><i class="fa fa-facebook-square fa-3x text-white mr-3"></i
                            ></a>
                            <i v-if="false" class="fa fa-instagram fa-3x"></i>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-brand text-center pt-3 pb-3">
            <img src="../../images/logo.png" alt="goLotus" />
        </div>
        <div class="footer-end text-center">&copy; {{ year }} goLOTUS, Inc.</div>
    </footer>
</template>

<script>
export default {
    name: "GoLotusFooter",
    data() {
        return {
            year: new Date().getFullYear(),
            golotus: [
                { title: "Home Page", url: "/" },
                { title: "Terms & Conditions", url: "/terms" },
                { title: "Privacy & Security", url: "/privacy-policy" },
            ],
            letushelp: [
                { title: "FAQ", url: "/faq" },
                { title: "Help Center", url: "/help" },
                { title: "Contact Us", url: "/contact" },
            ],
            aboutus: [{ title: "Our Story", url: "/about" }],
        };
    },
};
</script>

<style scoped lang="scss">
@import "../../sass/app";

$footer-end-color: #131a22;
$text-color: #ddd;

.footer-container {
    border-top: solid 5px $primary;
    font-size: 80%;
    color: $text-color;

    > .footer-brand {
        border-top: solid 1px rgba(255, 255, 255, 0.2);
        > img {
            max-width: 12rem;
        }
    }

    > .footer-end {
        color: white;
        background-color: $footer-end-color;
        font-size: 100%;
    }
}

.links {
    list-style-type: none;
    > li > a {
        color: $text-color;
    }
    > li > a:hover {
        text-decoration: none;
    }
}

@media (min-width: 576px) {
    .social {
        border-left: solid 1px white;

        > p {
            white-space: nowrap;
        }
    }
}
</style>
